module.exports = __webpack_public_path__ + "static/img/7.b8abbda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/7.png
// module id = M7jC
// module chunks = 0